import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'vectronic-invalid-positions-filter',
  templateUrl: './invalid-positions-filter.component.html',
  styleUrls: ['./invalid-positions-filter.component.scss'],
  imports: [CommonModule, MatIconModule, MatSlideToggleModule],
})
export class InvalidPositionsFilterComponent implements OnInit {
  filtersForm = input<FormGroup>();
  title = input<string>();

  hideInvalidPositions = false;
  destroyRef = inject(DestroyRef);
  ngOnInit() {
    this.hideInvalidPositions = this.filtersForm().get('hideInvalidPositions').value;

    this.filtersForm()
      .get('hideInvalidPositions')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        // hide filter control on reset button click
        if (value === null) {
          this.hideInvalidPositions = false;
        }
      });
  }

  toggle() {
    this.hideInvalidPositions = !this.hideInvalidPositions;
    this.filtersForm().get('hideInvalidPositions').setValue(this.hideInvalidPositions);
  }
}
